import { BuildingForm, BuildingListTable } from "./component";

interface BuildingProps {
  setIsSuccessModalOpen: (arg: boolean) => void;
  setIsErrorModalOpen: (arg: boolean) => void;
  setErrorMessage: (err: string) => void;
  handleScrollToTop: () => void;
}

export default function Building({
  setIsSuccessModalOpen,
  setIsErrorModalOpen,
  setErrorMessage,
  handleScrollToTop,
}: BuildingProps) {
  return (
    <div>
      <BuildingForm
        setIsErrorModalOpen={setIsErrorModalOpen}
        setIsSuccessModalOpen={setIsSuccessModalOpen}
        setErrorMessage={setErrorMessage}
      />
      <BuildingListTable handleScrollToTop={handleScrollToTop} />
    </div>
  );
}
